import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultNS, resources, defaultRecourse, returnNull } from './recources';

i18n.use(initReactI18next).init({
  lng: defaultRecourse,
  defaultNS,
  resources,
  // `returnNull` is the single source of truth in recources.ts, also consumed by the
  // `CustomTypeOptions.returnNull` type in src/@types/i18next.d.ts — see that file for why.
  returnNull,
});
